import React, {useEffect, useState} from 'react'
import { inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './PengenaanPajakAkun.service'

const PengenaanPajakAkunForm = ({envStore, match, history}) => {
  const { inputTypes, definition } = FormWrapper
  const [data, setData] = useState({loading: true, content: {}})

  // initial data
  useEffect(() => {
    async function initData() {
      if(match.params.id == 'baru') {
        setData({loading: false, content: {}})
        return true
      }
      const res = await service.getOne(match.params.id)
      setData({loading: false, content:res.data})
    }
    initData()
  }, ['match.params.id'])

  return (
    <FormWrapper
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={`/onpremise/pengenaan-pajak-akun`}
      baseId="mod-form-sample"
      title={t.translate('modules.pengenaanPajakAkun.formTitle')}
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      definitions={[
        // =====
        {
          inputType: inputTypes.INPUT,
          label: 'Nama',
          key: 'nama',
          type: 'text',
          required: true,
        },{
          inputType: inputTypes.INPUT,
          label: 'Keterangan',
          key: 'keterangan',
          type: 'text'
        },{
          inputType: inputTypes.INPUT,
          label: 'Posisi Akun',
          key: 'posisiAkun',
          type: 'text',
          required: true,
        },{
          inputType: inputTypes.CHECKBOX,
          label: 'Terutang Saat Jatuh Tempo',
          key: 'terutangSaatJatuhTempo',
          type: 'text',
          required: true,
        },
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/pengenaan-pajak-akun')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('envStore')(observer(PengenaanPajakAkunForm))
